import mixpanel from "mixpanel-browser";
const mixpanel_token = process.env.REACT_APP_MIXPANEL_TOKEN || false;
// TODO: Make this a class that can be extended for different tracking

// Prints a styled message to the console
function consoleOut(event, props = {}) {
  console.debug(
    `%c🛰  ${JSON.stringify(event) + " : " + JSON.stringify(props)}`,
    "background: #a0e9ff; color: #333; padding: 10px;"
  );
}

// Wrapper for the mixpanel.track function, which checks for props
function mixpanelTrack(event, props) {
  if (props) {
    mixpanel.track(event, props);
  } else {
    mixpanel.track(event);
  }
}

// Default Output
let Tracking = {
  track: consoleOut,
  log: consoleOut,
};

// Tracking is activated by including the mixpanel_token variable in .env
if (mixpanel_token) {
  mixpanel.init(mixpanel_token);
  Tracking = {
    track: mixpanelTrack,
    log: consoleOut,
  };
}

export default Tracking;
